import {BaseApi} from "@/http/api/BaseApi";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import errorHandler from "@/providers/ErrorHandler";

interface IResponse {
    data: object,
    statusCode: number,
    message: string,
}

export default class CommentServices extends BaseApi {

    getToken = () => {
        return Cookies.get("token");
    }

    createComment = async (data: any): Promise<boolean | undefined> => {
        try {
            const response: IResponse = await this.postFormData('profile/comments', data, {
                headers: {"Authorization": `Bearer ${this.getToken()}`},
            });

            if (response.statusCode === 200 || response.statusCode === 201) {
                toast.success(response.message, {position: "top-center"})
                return true
            } else {
                console.log(response)
                // const errorMsg = response.message || "لطفا ابتدا وارد شوید"
                // toast.error(errorMsg, {
                //     position: "top-center"
                // })
                // setTimeout(() => {
                //     window.location.href = "/auth";
                // },1000)
            }
        } catch (e: any) {
            errorHandler(e)
        }
    }

}